import './modal.css'
import React, { useState } from 'react';
import { Modal } from 'antd';

import AppleLogin from '../container/apple';
import FbLogin from '../container/facebook';
import Googlelogin from '../container/google';
import EmailPass from '../container/emailPass';

const Modaal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [show, setShow] = useState(true);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  

  return (
    <>
      <label style={{border:'none',outline:'none'}} onClick={showModal}>
       <div  style={{marginLeft:'18px'}}> Signup</div>
      </label>
      
      <Modal  
      open={isModalOpen}
       onOk={handleOk}
       onCancel={handleCancel}
      >
        
        <div className='modal-child'>
        <h1>Welcome to Turo</h1>
        <AppleLogin />   <br/>
        <FbLogin />   <br/>
        <Googlelogin />   <br/>
        <EmailPass />   <br/>
        </div>
      
        <div>

        </div>
      </Modal>
    </>
  );
};

export default Modaal;